import React from 'react';

import Skeleton from 'react-loading-skeleton';

import { shortDate, tileFigure } from './contractorFormat';

import KeyStatTile from 'CommonComponents/KeyStatTile';

export default function VenueContractorsTiles({ tiles, loading }) {
    const value = (content) => (loading || !tiles ? <Skeleton width="80px" height={28} /> : content);
    const subtitle = (content) => (loading || !tiles ? null : content);

    return (
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-6 tw-gap-3">
            <KeyStatTile
                title={$t('Packs allocated')}
                value={value(tileFigure(tiles?.packs))}
                subtitle={subtitle(
                    tiles?.functional_areas === 1
                        ? $t('across 1 functional area')
                        : $t('across {{count}} functional areas', { count: tiles?.functional_areas ?? 0 }),
                )}
            />
            <KeyStatTile
                title={$t('Days with contractors')}
                value={value(tileFigure(tiles?.days))}
                subtitle={subtitle(
                    $t('{{session}} session · {{nonSession}} non-session', {
                        session: tiles?.session_days ?? 0,
                        nonSession: tiles?.non_session_days ?? 0,
                    }),
                )}
            />
            <KeyStatTile title={$t('Contractor shifts')} value={value(tileFigure(tiles?.shifts))} subtitle={subtitle($t('people × shifts × days'))} />
            <KeyStatTile
                title={$t('Hours')}
                value={value(tileFigure(tiles?.hours))}
                subtitle={subtitle($t('avg {{hours}}h per shift', { hours: tileFigure(tiles?.avg_hours_per_shift, 1) }))}
            />
            <KeyStatTile
                title={$t('Peak headcount')}
                value={value(tileFigure(tiles?.peak_headcount))}
                subtitle={subtitle(tiles?.peak_date ? $t('on site at once, {{date}}', { date: shortDate(tiles.peak_date) }) : $t('on site at once'))}
            />
            <KeyStatTile title={$t('Contractor cost')} value={value(tileFigure(tiles?.cost))} subtitle={subtitle($t('Latest Estimate'))} />
        </div>
    );
}
